import { PathWithId } from "@constellation-academy/epic-ui";

export class AppBuildNumberPath extends PathWithId<typeof AppBuildNumberPath> {
	static readonly pathKey = "appBuildNumber";
	static readonly pathName = "app-build-number";
}
